import React, { useState, useEffect } from "react";
import axios from "axios";
import { FiBell, FiSend, FiUsers, FiCheckCircle, FiXCircle, FiTrash2, FiImage, FiLink, FiX, FiClock, FiUserPlus, FiTrendingUp, FiUserX } from "react-icons/fi";

const InAppNotifications = () => {
  const [loading, setLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [formData, setFormData] = useState({
    title: "",
    message: "",
    type: "info", // info, success, warning, error
    targetAudience: "all",
    userIds: "",
    image: null,
    targetDestination: "",
    expiryDate: "",
    language: "all", // all or specific language
    gender: "all", // all, male, female
    osType: "all", // all, android, ios
  });
  const [notifications, setNotifications] = useState([]);
  const [stats, setStats] = useState({
    totalActive: 0,
    totalSent: 0,
    expired: 0,
  });

  // const audienceOptions = [
  //   { id: "all", label: "All Users", icon: <FiUsers />, count: 0 },
  //   { id: "new_users", label: "New Users", icon: <FiUserPlus />, count: 0 },
  //   { id: "last_7_days", label: "Last 7 Days Active Users", icon: <FiTrendingUp />, count: 0 },
  //   { id: "active", label: "Active Users", icon: <FiCheckCircle />, count: 0 },
  //   { id: "last_7_days_inactive", label: "Last 7 Days InActive Users", icon: <FiUserX />, count: 0 },
  //   { id: "specific", label: "Specific Users", icon: <FiUsers />, count: 0 },
  // ];



  const audienceOptions = [
    { id: "all", label: "All Users", icon: <FiUsers /> },
    { id: "new", label: "New Users (Last 7 Days)", icon: <FiUserPlus /> },
    { id: "last7days", label: "Last 7 Days Active Users", icon: <FiTrendingUp /> },
    { id: "active", label: "Active Users", icon: <FiCheckCircle /> },
    { id: "specific", label: "Specific Users", icon: <FiUsers /> },
  ];





  const screenPaths = [
    { value: "", label: "No Destination" },
    { value: "app://home", label: "Home Screen" },
    { value: "app://profile", label: "Profile Screen" },
    { value: "app://settings", label: "Settings Screen" },
    { value: "app://notifications", label: "Notifications Screen" },
    { value: "app://wallet", label: "Wallet Screen" },
    { value: "app://gifts", label: "Gifts Screen" },
    { value: "app://coin-packages", label: "Coin Packages Screen" },
    { value: "app://purchase-history", label: "Purchase History Screen" },
    { value: "app://call-history", label: "Call History Screen" },
  ];

  const languageOptions = [
    { value: "all", label: "All Languages" },
    { value: "en", label: "English" },
    { value: "te", label: "Telugu" },
    { value: "hi", label: "Hindi" },
    { value: "kn", label: "Kannada" },
    { value: "ta", label: "Tamil" },
    { value: "ml", label: "Malayalam" },
  ];

  const genderOptions = [
    { value: "all", label: "All" },
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
  ];

  const osTypeOptions = [
    { value: "all", label: "All" },
    { value: "android", label: "Android" },
    { value: "ios", label: "iOS" },
  ];

  useEffect(() => {
    fetchStats();
    fetchNotifications();
  }, []);

  const fetchStats = async () => {
    try {
      // Replace with your actual API endpoint
       const res = await axios.get("api/v1/admin/notifications/stats");
       setStats(res.data.data);
    } catch (error) {
      console.error("Error fetching stats:", error);
    }
  };

  const fetchNotifications = async () => {
    try {
      // Replace with your actual API endpoint
      const res = await axios.get("/api/v1/admin/notifications");
      setNotifications(res.data.data);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  const handleChange = (e) => {
    if (e.target.name === "image") {
      const file = e.target.files[0];
      if (file) {
        setFormData({ ...formData, image: file });
        const reader = new FileReader();
        reader.onloadend = () => {
          setImagePreview(reader.result);
        };
        reader.readAsDataURL(file);
      }
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const handleRemoveImage = () => {
    setFormData({ ...formData, image: null });
    setImagePreview(null);
  };


const handleSend = async () => {
  if (!formData.title || !formData.message) {
    alert("Please fill in title and message");
    return;
  }

  setLoading(true);
  try {
    const formDataToSend = new FormData();

    formDataToSend.append("title", formData.title);
    formDataToSend.append("message", formData.message);
    formDataToSend.append("type", formData.type);

    // ✅ FIXED
    formDataToSend.append("target", formData.targetAudience);

    if (formData.targetAudience === "specific") {
      formDataToSend.append(
        "userIds",
        JSON.stringify(
          formData.userIds.split(",").map(id => id.trim())
        )
      );
    }

    if (formData.image) {
      formDataToSend.append("image", formData.image);
    }

    if (formData.targetDestination) {
      formDataToSend.append("targetDestination", formData.targetDestination);
    }

    if (formData.expiryDate) {
      formDataToSend.append(
        "expiryAt",
        new Date(formData.expiryDate).toISOString()
      );
    }
    
    // if (formData.language && formData.language !== "all") {
    //   formDataToSend.append("language", formData.language);
    // }
    
    // if (formData.gender && formData.gender !== "all") {
    //   formDataToSend.append("gender", formData.gender);
    // }
    
    // if (formData.osType && formData.osType !== "all") {
    //   formDataToSend.append("osType", formData.osType);
    // }


    const filters = {};

if (formData.language !== "all") filters.language = formData.language;
if (formData.gender !== "all") filters.gender = formData.gender;
if (formData.osType !== "all") filters.osType = formData.osType;

formDataToSend.append("filters", JSON.stringify(filters));


    await axios.post(
      "/api/v1/admin/notifications",
      formDataToSend,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    alert("In-app notification created successfully!");

    setFormData({
      title: "",
      message: "",
      type: "info",
      targetAudience: "all",
      userIds: "",
      image: null,
      targetDestination: "",
      expiryDate: "",
      language: "all",
      gender: "all",
      osType: "all",
    });

    setImagePreview(null);
    fetchStats();
    fetchNotifications();

  } catch (error) {
    console.error("Error creating notification:", error);
    alert("Failed to create notification");
  } finally {
    setLoading(false);
  }
};


  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this notification?")) {
      return;
    }

    try {
      // Replace with your actual API endpoint
      await axios.delete(`api/v1/admin/notifications/${id}`);
      alert("Notification deleted successfully!");
      fetchStats();
      fetchNotifications();
    } catch (error) {
      console.error("Error deleting notification:", error);
      alert("Failed to delete notification. Please try again.");
    }
  };

  const getTypeColor = (type) => {
    switch (type) {
      case "success":
        return "bg-green-500";
      case "warning":
        return "bg-yellow-500";
      case "error":
        return "bg-red-500";
      default:
        return "bg-blue-500";
    }
  };

  return (
    <div className="min-h-screen bg-white p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-extrabold text-[var(--primary-solid)] flex items-center gap-3">
            <FiBell className="text-3xl" />
            In-App Notifications
          </h1>
          <p className="text-[var(--black-text)]/70 mt-2">
            Create and manage in-app notifications for users
          </p>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
          <div className="bg-gradient-to-br from-green-500/10 to-green-500/5 border-2 border-green-500/20 rounded-xl p-6 shadow-lg">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-green-400 uppercase tracking-wider">
                  Active
                </p>
                <p className="text-3xl font-bold text-green-400">
                  {stats.totalActive}
                </p>
              </div>
              <div className="text-4xl text-green-400">
                <FiCheckCircle />
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-blue-500/10 to-blue-500/5 border-2 border-blue-500/20 rounded-xl p-6 shadow-lg">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-blue-400 uppercase tracking-wider">
                  Total Sent
                </p>
                <p className="text-3xl font-bold text-blue-400">
                  {stats.totalSent}
                </p>
              </div>
              <div className="text-4xl text-blue-400">
                <FiSend />
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-orange-500/10 to-orange-500/5 border-2 border-orange-500/20 rounded-xl p-6 shadow-lg">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-orange-400 uppercase tracking-wider">
                  Expired
                </p>
                <p className="text-3xl font-bold text-orange-400">
                  {stats.expired}
                </p>
              </div>
              <div className="text-4xl text-orange-400">
                <FiXCircle />
              </div>
            </div>
          </div>
        </div>

        {/* Target Audience Selection - Tile Cards */}
        <div className="bg-white border-2 border-gray-200 rounded-xl p-6 mb-8">
          <h2 className="text-xl font-bold text-[var(--primary-solid)] mb-4 flex items-center gap-2">
            <FiUsers />
            Select Target Audience
          </h2>
          <p className="text-sm text-[var(--black-text)]/70 mb-4">
            Choose which users should receive this notification
          </p>
          <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2">
            {audienceOptions.map((audience, index) => {
              const colors = [
                { bg: "bg-gradient-to-br from-blue-500/10 to-blue-500/5 border-blue-500/20", text: "text-blue-400", icon: "text-blue-400" },
                { bg: "bg-gradient-to-br from-green-500/10 to-green-500/5 border-green-500/20", text: "text-green-400", icon: "text-green-400" },
                { bg: "bg-gradient-to-br from-purple-500/10 to-purple-500/5 border-purple-500/20", text: "text-purple-400", icon: "text-purple-400" },
                { bg: "bg-gradient-to-br from-orange-500/10 to-orange-500/5 border-orange-500/20", text: "text-orange-400", icon: "text-orange-400" },
                { bg: "bg-gradient-to-br from-teal-500/10 to-teal-500/5 border-teal-500/20", text: "text-teal-400", icon: "text-teal-400" },
              ];
              const color = colors[index % colors.length];

              return (
                <button
                  key={audience.id}
                  onClick={() => setFormData({ ...formData, targetAudience: audience.id })}
                  className={`p-3 rounded-xl border-2 transition-all duration-200 text-left ${
                    formData.targetAudience === audience.id
                      ? `${color.bg} ${color.text} shadow-lg scale-105`
                      : `bg-white border-gray-200 hover:border-gray-300 hover:shadow-md`
                  }`}
                >
                  <div className="flex items-center justify-between mb-2">
                    <div className={`text-2xl ${formData.targetAudience === audience.id ? color.icon : "text-[var(--primary-solid)]"}`}>
                      {audience.icon}
                    </div>
                    {formData.targetAudience === audience.id && (
                      <span className="px-2 py-0.5 bg-[var(--yellow)] text-black text-xs font-semibold rounded-full shadow-sm">
                        Selected
                      </span>
                    )}
                  </div>
                  <p className={`font-bold text-xs mb-1 ${formData.targetAudience === audience.id ? color.text : "text-[var(--black-text)]"}`}>
                    {audience.label}
                  </p>
                  <p className={`text-xs ${formData.targetAudience === audience.id ? `${color.text} opacity-80` : "text-[var(--black-text)]/60"}`}>
                    Target specific user groups
                  </p>
                </button>
              );
            })}
          </div>

          {formData.targetAudience === "specific" && (
            <div className="mt-4">
              <label className="block text-sm font-medium text-[var(--black-text)] mb-2">
                User IDs (comma-separated)
              </label>
              <input
                type="text"
                name="userIds"
                value={formData.userIds}
                onChange={handleChange}
                placeholder="e.g., 123, 456, 789"
                className="w-full px-4 py-2 border-2 border-gray-200 bg-white text-[var(--black-text)] rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)]"
              />
            </div>
          )}

          {/* Additional Filters */}
          <div className="mt-6 pt-6 border-t border-gray-200">
            <h3 className="text-lg font-semibold text-[var(--primary-solid)] mb-4">
              Additional Filters
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {/* Language Filter */}
              <div>
                <label className="block text-sm font-medium text-[var(--black-text)] mb-2">
                  Language
                </label>
                <select
                  name="language"
                  value={formData.language}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border-2 border-gray-200 bg-white text-[var(--black-text)] rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)] appearance-none"
                >
                  {languageOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>

              {/* Gender Filter */}
              <div>
                <label className="block text-sm font-medium text-[var(--black-text)] mb-2">
                  Gender
                </label>
                <select
                  name="gender"
                  value={formData.gender}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border-2 border-gray-200 bg-white text-[var(--black-text)] rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)] appearance-none"
                >
                  {genderOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>

              {/* OS Type Filter */}
              <div>
                <label className="block text-sm font-medium text-[var(--black-text)] mb-2">
                  OS Type
                </label>
                <select
                  name="osType"
                  value={formData.osType}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border-2 border-gray-200 bg-white text-[var(--black-text)] rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)] appearance-none"
                >
                  {osTypeOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* Create Notification Form */}
        <div className="bg-white border-2 border-gray-200 rounded-xl p-6 mb-8">
          <h2 className="text-xl font-bold text-[var(--primary-solid)] mb-6 flex items-center gap-2">
            <FiSend />
            Create New Notification
          </h2>

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-[var(--black-text)] mb-2">
                Title
              </label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                placeholder="Enter notification title"
                className="w-full px-4 py-2 border-2 border-gray-200 bg-white text-[var(--black-text)] rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)]"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-[var(--black-text)] mb-2">
                Message
              </label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Enter notification message"
                rows="4"
                className="w-full px-4 py-2 border-2 border-gray-200 bg-white text-[var(--black-text)] rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)]"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-[var(--black-text)] mb-2">
                Type
              </label>
              <select
                name="type"
                value={formData.type}
                onChange={handleChange}
                className="w-full px-4 py-2 border-2 border-gray-200 bg-white text-[var(--black-text)] rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)]"
              >
                <option value="info">Info</option>
                <option value="success">Success</option>
                <option value="warning">Warning</option>
                <option value="error">Error</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-[var(--black-text)] mb-2">
                Image (Optional)
              </label>
              {imagePreview ? (
                <div className="relative">
                  <img
                    src={imagePreview}
                    alt="Preview"
                    className="w-full h-48 object-cover rounded-lg border-2 border-gray-200"
                  />
                  <button
                    type="button"
                    onClick={handleRemoveImage}
                    className="absolute top-2 right-2 bg-red-500 text-white p-2 rounded-full hover:bg-red-600 transition"
                  >
                    <FiX />
                  </button>
                </div>
              ) : (
                <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-gray-200 border-dashed rounded-lg cursor-pointer hover:bg-gray-50 transition">
                  <div className="flex flex-col items-center justify-center pt-5 pb-6">
                    <FiImage className="text-3xl text-[var(--primary-solid)] mb-2" />
                    <p className="mb-2 text-sm text-[var(--black-text)]">
                      <span className="font-semibold">Click to upload</span> or drag and drop
                    </p>
                    <p className="text-xs text-[var(--black-text)]/70">PNG, JPG, GIF up to 10MB</p>
                  </div>
                  <input
                    type="file"
                    name="image"
                    accept="image/*"
                    onChange={handleChange}
                    className="hidden"
                  />
                </label>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-[var(--black-text)] mb-2">
                Target Destination (Optional)
              </label>
              <div className="relative">
                <FiLink className="absolute left-3 top-3 text-[var(--primary-solid)]" />
                <select
                  name="targetDestination"
                  value={formData.targetDestination}
                  onChange={handleChange}
                  className="w-full pl-10 pr-4 py-2 border-2 border-gray-200 bg-white text-[var(--black-text)] rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)] appearance-none"
                >
                  {screenPaths.map((path) => (
                    <option key={path.value} value={path.value}>
                      {path.label}
                    </option>
                  ))}
                </select>
              </div>
              <p className="text-xs text-[color:var(--yellow)/0.7] mt-1">
                Screen path where users will be redirected when they tap the notification
              </p>
            </div>

            <div>
              <label className="block text-sm font-medium text-[var(--black-text)] mb-2">
                Expiry Date (Optional)
              </label>
              <input
                type="date"
                name="expiryDate"
                value={formData.expiryDate}
                onChange={handleChange}
                className="w-full px-4 py-2 border-2 border-gray-200 bg-white text-[var(--black-text)] rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--primary-solid)]/50 focus:border-[var(--primary-solid)]"
              />
            </div>

            <button
              onClick={handleSend}
              disabled={loading}
              className="w-full px-6 py-3 bg-[var(--yellow)] text-white rounded-lg font-semibold hover:opacity-90 transition-all disabled:opacity-50 flex items-center justify-center gap-2"
            >
              {loading ? (
                <>
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  Creating...
                </>
              ) : (
                <>
                  <FiSend />
                  Create Notification
                </>
              )}
            </button>
          </div>
        </div>

        {/* Notifications List */}
        <div className="bg-white border-2 border-gray-200 rounded-xl p-6">
          <h2 className="text-xl font-bold text-[var(--primary-solid)] mb-6 flex items-center gap-2">
            <FiUsers />
            Active Notifications
          </h2>

          {notifications.length === 0 ? (
            <p className="text-center text-[color:var(--yellow)/0.7] py-8">
              No notifications created yet
            </p>
          ) : (
            <div className="space-y-4">
              {notifications.map((notification, index) => (
                <div
                  key={index}
                  className="border-2 border-gray-200 rounded-xl p-4 hover:shadow-md transition-all"
                >
                  <div className="flex items-start justify-between gap-4">
                    {notification.image && (
                      <div className="flex-shrink-0">
                        <img
                          src={notification.image}
                          alt="Notification"
                          className="w-24 h-24 object-cover rounded-lg border border-gray-200"
                        />
                      </div>
                    )}
                    <div className="flex-1">
                      <div className="flex items-center gap-3 mb-2">
                        <span
                          className={`w-3 h-3 rounded-full ${getTypeColor(
                            notification.type
                          )}`}
                        />
                        <h3 className="font-bold text-[var(--primary-solid)]">
                          {notification.title}
                        </h3>
                        <span
                          className={`px-2 py-1 rounded-full text-xs ${
                            notification.status === "active"
                              ? "bg-green-500 text-white"
                              : "bg-gray-500 text-white"
                          }`}
                        >
                          {notification.status || "Active"}
                        </span>
                      </div>
                      <p className="text-[color:var(--yellow)/0.9] mb-3">
                        {notification.message}
                      </p>
                      {notification.targetDestination && (
                        <div className="mb-2">
                          <a
                            href={notification.targetDestination}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-500 hover:underline flex items-center gap-1 text-sm"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <FiLink className="text-xs" />
                            {notification.targetDestination}
                          </a>
                        </div>
                      )}
                      <div className="flex flex-wrap items-center gap-4 text-xs text-[color:var(--yellow)/0.7]">
                        <span>
                          Type: <strong className="capitalize">{notification.type}</strong>
                        </span>
                        <span>
                          Target:{" "}
                          <strong>
                            {notification.targetAudience === "all" && "All Users"}
                            {notification.targetAudience === "new_users" && "New Users"}
                            {notification.targetAudience === "last_7_days" && "Last 7 Days Active Users"}
                            {notification.targetAudience === "active" && "Active Users"}
                            {notification.targetAudience === "last_7_days_inactive" && "Last 7 Days InActive"}
                            {notification.targetAudience === "specific" && "Specific Users"}
                          </strong>
                        </span>
                        {notification.expiryDate && (
                          <span className="flex items-center gap-1">
                            <FiClock className="text-xs" />
                            Expires:{" "}
                            <strong>
                              {new Date(notification.expiryDate).toLocaleDateString()}
                            </strong>
                          </span>
                        )}
                        <span>
                          Created:{" "}
                          <strong>
                            {notification.createdAt
                              ? new Date(notification.createdAt).toLocaleDateString()
                              : "N/A"}
                          </strong>
                        </span>
                      </div>
                    </div>
                    <button
                      onClick={() => handleDelete(notification.id)}
                      className="ml-4 p-2 text-red-500 hover:bg-red-50 rounded-lg transition flex-shrink-0"
                    >
                      <FiTrash2 />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InAppNotifications;
